/*
 * Text component
 */
import React from 'react';
import Base from './base.jsx';
import {
  castDataType,
  DataType
} from '../common.jsx';
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";

export default class Text extends Base {
        static get ANSWER_DEPENDENT() {
          return false
        }

        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'text';
        }

        static icon(){
            return <i className="fa fa-paragraph"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                text: 'text_default_text'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                text: 'text',
                guideline: false,
            });
        }

        renderView() {
            return (<div dangerouslySetInnerHTML={{__html: Helpers.linkURLs(Helpers.simpleFormat(this.getText('text')))}}></div>);
        }

        renderPrettyView() {
            // Doesn't have label and can toggle hide by using guideline
            return (!this.props.content.guideline ?
                this.renderView()
             : null);
        }

        renderSettings() {
            return (
                <div>
                    <Setting.LongTextField name="text" label={I18n.t('field_text', {scope: 'fe'})} value={this.getText('text')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="guideline" label={I18n.t('guideline', {scope: 'fe'})} value={this.props.content.guideline} onChange={this.updateSettings} />
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.guideline = castDataType(content.guideline, DataType.BOOLEAN);
        }
}
